module.exports = __webpack_public_path__ + "img/3csm_Ersa-Wave-POWERFLOWULTRA-01-900x675_e1f30ae5a1.f27bfd44.png";